import { objectSchemaOf } from '../helpers';
import { revisionGlobalSchema } from './configModel';

export interface ILoadParams {
  revision?: number;
}

export const loadParamsSchema = objectSchemaOf<ILoadParams>({
  revision: revisionGlobalSchema.optional(),
});
